// extracted by mini-css-extract-plugin
export var externalLink = "_9d-0";
export var internalLinkLabel = "_9d-1";